"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var theme_ui_1 = require("theme-ui");
exports.LoadingBox = function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b, children = _a.children, sx = _a.sx;
    return loading ? (react_1.default.createElement(theme_ui_1.Flex, { sx: __assign({ margin: "0 auto", padding: "0 0.5rem", width: ["3.188rem", " 6.25rem"], height: ["3.188rem", " 6.25rem"], position: "relative", alignItems: "center", transform: "skew(-27deg)" }, sx) },
        react_1.default.createElement(styled_1.Loader, null),
        react_1.default.createElement(styled_1.Loader, null),
        react_1.default.createElement(styled_1.Loader, null),
        react_1.default.createElement(styled_1.Loader, null),
        react_1.default.createElement(styled_1.Loader, null))) : (react_1.default.createElement(react_1.default.Fragment, null, children));
};
